import {TokenBody} from '../model/token-body';
import { Injectable } from "@angular/core";
import * as jwt_decode from "jwt-decode";
import {CookieService} from "ngx-cookie-service";
import {environment} from "../../../../environments/environment";

const TOKEN_TAG = 'jwt_' + environment.environmentName;

@Injectable()
export class TokenService {
  private token: string;
  private refreshToken: string;

  constructor(
    private readonly cookies: CookieService,
  ) {
    this.loadTokenFromCookies();
  }

  private get decodedToken(): TokenBody {
    return jwt_decode(this.token) as TokenBody;
  }

  public doesTokenExistLocally(): boolean {
    return Boolean(this.token);
  }

  public getToken(): string {
    return this.token;
  }

  public getRefreshToken(): string {
    return this.refreshToken;
  }

  public getLoginId(): number {
    return this.decodedToken?.LoginId
  }

  public getCulture(): string {
    return this.decodedToken?.Culture
  }

  public getUsername(): string {
    return this.decodedToken?.Username
  }

  public getFirstName(): string {
    return this.decodedToken?.FirstName
  }

  public getLastName(): string {
    return this.decodedToken?.LastName
  }

  public loadTokenFromCookies(): void {
    this.token = this.cookies.get(TOKEN_TAG);
  }

  public clearTokens() {
    this.token = null;
    this.refreshToken = null;
  }

  public setToken(token: string) {
    this.token = token;
  }

  public setRefreshToken(token: string) {
    this.refreshToken = token;
  }

  public isTokenExpired(): boolean {
    if (!this.decodedToken) {
      return true;
    }
    const date = this.getTokenExpirationDate();
    if (date === undefined) {
      return false;
    }
    return !(date.valueOf() > new Date().valueOf());
  }

  public getLicenseAgreed() {
    return this.decodedToken.LicenseAgreed;
  }

  public setLicenseAgreed(value = true) {
    this.decodedToken.LicenseAgreed = value;
  }

  private getTokenExpirationDate(): Date {
    if (this.decodedToken.exp === undefined) {
      return null;
    }

    const date = new Date(0);
    date.setUTCSeconds(this.decodedToken.exp);
    return date;
  }
}
